import {
	Modal,
	MimaButton,
	MimaInput,
	MimaDropdown,
	MimaTextArea,
	MimaText,
	ReceiptCheckBox as RCB,
	MimaPaginatedDropdown,
} from '../../components';
import styles from '../../assets/styles/Inventory/Inventory.module.scss';
import { Field, FieldArray, Formik } from 'formik';
import { currencies } from '../../utils/utils';
import { businessStore, inventoryStore } from '../../stores';
import React from 'react';

const FieldInput = ({ field, ...props }) => {
	return <MimaInput {...field} {...props} />;
};

const FieldSelect = ({ field, ...props }) => {
	return <MimaDropdown {...field} {...props} />;
};

const AddVariationMain = ({
	closeModal,
	loading,
	validationSchema,
	onSubmit,
	varyType,
	setVaryType,
	selectedProduct,
	onSelect,
}) => {
	const variationTypeData = [
		'Colour',
		'Size',
		'Weight',
		'Length',
		'Yards',
		'Time',
		'Soft',
		'Mild',
		'Hard',
		'Portion',
		'Bowl',
		'Bottle',
		'Carton',
		'Litre (lt)',
		'Bundle',
		'Sachets',
		'Millilitre (ml)',
		'Ounce (Oz)',
		'Gallon',
		'Inches',
		'Session',
		'Hours',
		'Location',
		'Grade',
		'Day',
		'Month',
		'Minutes',
	];

	const eurAmount = inventoryStore?.eurPrice;
	const gbpAmount = inventoryStore?.gbpPrice;

	return (
		<Modal closeModal={closeModal} goBack={closeModal}>
			<MimaText variant="subtitleBold" align="center" mb={2} width={38}>
				Add Stock
			</MimaText>
			<Formik
				initialValues={{
					costPrice: 0,
					title: '',
					sellingPrice: 0,
					quantity: 0,
					currencyCode: 'NGN',
					productSelect: '',
					productSelectValue: '',
					description: '',
					//shippingFee: 0,
					hasMulticurrency: false,
					sellingPriceUSD: 0,
					sellingPriceGBP: 0,
					sellingPriceEUR: 0,
					lowStockCount: 0,
					variations: [{ value: '', type: '' }],
					splitPercentage: 0,
					validCondition: false,
					productCondition: 'NEW',
				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}>
				{({
					handleChange,
					handleBlur,
					handleSubmit,
					values,
					errors,
					touched,
					setFieldValue,
				}) => (
					<div>
						<MimaPaginatedDropdown
							type="text"
							mt={2}
							labelTitle="Select Product Type to create stock for"
							name="productSelect"
							id="productSelect"
							value={values.productSelectValue}
							placeholder="Select a product type"
							queryKey={[businessStore.bId, 'products']}
							optionLabel="name"
							touched={touched.productSelect}
							error={errors.productSelect}
							url="/products/collection/business"
							getPageValue={page => page?.data?.value || []}
							getPageTotalCount={lastPage => lastPage?.data?.totalCounts || 0}
							onChange={data => {
								setFieldValue('productSelect', data._id);
								setFieldValue('productSelectValue', data.name);
								inventoryStore.setSelectedProduct(data);

								if (data.type === 'Product') {
									setFieldValue('validCondition', true);
								} else {
									setFieldValue('validCondition', false);
								}
							}}
						/>

						<MimaInput
							type="text"
							labelTitle="Stock Name"
							name="title"
							id="title"
							value={values.title}
							onChange={handleChange}
							error={errors.title}
							touched={touched.title}
							onBlur={handleBlur}
						/>
						<div className={styles.type}>
							<MimaText variant="small" mb={1} mt={3}>
								Condition of stock
							</MimaText>
							<div className="modal__beside">
								<RCB
									title="Brand New"
									onChange={() => {
										setFieldValue('productCondition', 'NEW');
									}}
									checked={values.productCondition === 'NEW'}
									value={'NEW'}
									name="productCondition"
								/>
								<RCB
									title="Fairly Used"
									onChange={() => {
										setFieldValue('productCondition', 'USED');
									}}
									checked={values.productCondition === 'USED'}
									value={'USED'}
									name="productCondition"
								/>
							</div>
							{errors.productCondition ? (
								<div className={styles.error}>
									{''}
									{touched.productCondition && errors.productCondition}
									{''}
								</div>
							) : null}
						</div>
						<MimaDropdown
							labelTitle="Select Currency"
							name="currencyCode"
							value={values.currencyCode}
							placeholder={values.currencyCode}
							id="currencyCode"
							currentValue={values.currencyCode}
							onChange={data => {
								setFieldValue('currencyCode', data.key);
							}}
							data={currencies}
							touched={touched.currencyCode}
							error={errors.currencyCode}
						/>
						<FieldArray name="variations">
							{({ push, remove }) => (
								<React.Fragment>
									{values.variations.map(
										(_, i) =>
											(varyType || values.validCondition) && (
												<div key={i}>
													<div className="modal__beside">
														<Field
															as="select"
															component={FieldSelect}
															name={`variations.${i}.type`}
															value={values.variations[i].type}
															onChange={e => {
																setFieldValue(`variations.${i}.type`, e.value);
															}}
															placeholder={
																values.variations[i].type || 'Select type'
															}
															data={variationTypeData.map(item => ({
																key: item,
																value: item,
															}))}
															labelTitle="Stock Tag"
															width={18}
														/>
														<Field
															name={`variations.${i}.value`}
															type="text"
															component={FieldInput}
															labelTitle={`${values.variations[i].type || ''} Value`}
															width={18}
														/>
													</div>

													{i >= 0 ? (
														<MimaButton
															title="Remove"
															variant="filter"
															type="button"
															buttonColor="var(--color-error)"
															width={10}
															onClick={() => {
																if (values.variations.length === 1) {
																	setVaryType(false);
																} else {
																	remove(i);
																}
															}}
														/>
													) : (
														''
													)}
													<div className={styles.employee__list_line}> </div>
												</div>
											)
									)}
									<MimaButton
										title={varyType ? 'Add Another stock Tag' : 'Add stock Tag'}
										variant="text"
										type="button"
										onClick={() => {
											if (!varyType && values.variations.length === 1) {
												setVaryType(true);
											} else {
												push({
													value: '',
													type: '',
												});
											}
										}}
										width={38}
									/>
								</React.Fragment>
							)}
						</FieldArray>

						<MimaTextArea
							type="text"
							labelTitle="Description"
							name="description"
							id="description"
							value={values.description}
							onChange={handleChange}
							error={errors.description}
							touched={touched.description}
							onBlur={handleBlur}
						/>
						<div className="modal__beside">
							{selectedProduct?.type === 'Product' ? (
								<MimaInput
									type="number"
									labelTitle="Cost Price"
									name="costPrice"
									id="costPrice"
									value={values.costPrice}
									onChange={handleChange}
									error={errors.costPrice}
									touched={touched.costPrice}
									onBlur={handleBlur}
									width={18}
								/>
							) : (
								''
							)}
							<MimaInput
								type="number"
								labelTitle="Selling Price"
								name="sellingPrice"
								id="sellingPrice"
								value={values.sellingPrice}
								onChange={handleChange}
								error={errors.sellingPrice}
								touched={touched.sellingPrice}
								onBlur={handleBlur}
								width={selectedProduct.type === 'Product' ? 18 : 38}
							/>
						</div>
						<div className="modal__beside">
							{/* {values.validCondition ? (<MimaInput
								type="number"
								labelTitle="Available Quantity"
								name="quantity"
								id="quantity"
								value={values.quantity}
								onChange={handleChange}
								error={errors.quantity}
								touched={touched.quantity}
								onBlur={handleBlur}
								width={18}
							/>) : ""} */}
							{selectedProduct?.type === 'Product' ? (
								<MimaInput
									type="number"
									labelTitle="Available Quantity"
									name="quantity"
									id="quantity"
									value={values.quantity}
									onChange={handleChange}
									error={errors.quantity}
									touched={touched.quantity}
									onBlur={handleBlur}
									width={38}
								/>
							) : (
								''
							)}
							{/* <MimaInput
								type="number"
								labelTitle={values.validCondition ? "Shipping Fee" : "Logistics Fee"}
								name="shippingFee"
								id="shippingFee"
								value={values.shippingFee}
								onChange={handleChange}
								error={errors.shippingFee}
								touched={touched.shippingFee}
								onBlur={handleBlur}
								width={values.validCondition ? 18 : 38}
							/> */}
							{/* <MimaInput
								type="number"
								labelTitle="Enter Low Stock Quantity"
								name="lowStockCount"
								mb={2}
								value={values.lowStockCount}
								onChange={handleChange}
								onBlur={handleBlur}
								touched={touched.lowStockCount}
							/> */}
						</div>

						{selectedProduct?.type === 'Product' ? (
							<MimaInput
								type="number"
								labelTitle="Enter Low Stock Quantity"
								name="lowStockCount"
								mb={2}
								value={values.lowStockCount}
								onChange={handleChange}
								onBlur={handleBlur}
								touched={touched.lowStockCount}
							/>
						) : (
							''
						)}

						{/* Multicurrency input start */}

						<div className={styles.invoice__checks_group}>
							<MimaText variant="small" mb={1} mt={1}>
								Do you want to accept multicurrency for this stock?
							</MimaText>
							<div className="modal__beside">
								<RCB
									title="YES"
									onChange={() => {
										setFieldValue('hasMulticurrency', true);
									}}
									checked={values.hasMulticurrency}
									value={true}
									name="hasMulticurrency"
								/>
								<RCB
									title="NO"
									onChange={() => {
										setFieldValue('hasMulticurrency', false);
									}}
									checked={!values.hasMulticurrency}
									value={false}
									name="hasMulticurrency"
								/>
							</div>
							{errors.hasMulticurrency ? (
								<div className={styles.error}>
									{''}
									{touched.hasMulticurrency && errors.hasMulticurrency}
									{''}
								</div>
							) : null}
						</div>

						{values.hasMulticurrency && (
							<>
								<MimaInput
									type="number"
									labelTitle="Enter USD amount"
									name="sellingPriceUSD"
									id="sellingPriceUSD"
									value={values.sellingPriceUSD}
									onChange={handleChange}
									error={errors.sellingPriceUSD}
									touched={touched.sellingPriceUSD}
									onBlur={e => {
										handleBlur(e);
										onSelect(values);
										setFieldValue('sellingPriceEUR', eurAmount);
										setFieldValue('sellingPriceGBP', gbpAmount);
									}}
									mt={1}
								/>

								<div className={styles.addProduct__beside}>
									<MimaInput
										type="number"
										labelTitle="GBP"
										name="sellingPriceGBP"
										id="sellingPriceGBP"
										value={values.sellingPriceGBP}
										onChange={handleChange}
										error={errors.sellingPriceGBP}
										touched={touched.sellingPriceGBP}
										onBlur={handleBlur}
										width={18}
									/>

									<MimaInput
										type="number"
										labelTitle="EUR"
										name="sellingPriceEUR"
										id="sellingPriceEUR"
										value={values.sellingPriceEUR}
										onChange={handleChange}
										error={errors.sellingPriceEUR}
										touched={touched.sellingPriceEUR}
										onBlur={handleBlur}
										width={18}
									/>
								</div>
							</>
						)}
						{/* Multicurrency input end */}

						{inventoryStore?.selectedProduct?.hasSplit && (
							<MimaInput
								type="number"
								min={0}
								max={100}
								labelTitle={`Percentage of ${inventoryStore.selectedProduct?.split?.type} split for ${inventoryStore.selectedProduct?.split?.name}?`}
								name="splitPercentage"
								id="splitPercentage"
								value={values.splitPercentage}
								onChange={handleChange}
								touched={touched.splitPercentage}
								onBlur={handleBlur}
							/>
						)}
						<MimaButton
							title="Continue"
							onClick={handleSubmit}
							variant="form"
							loading={loading}
						/>
					</div>
				)}
			</Formik>
		</Modal>
	);
};

export default AddVariationMain;
